<!-- 信用支付页面 -->
<template>
  <div class="sld_my_balance">
    <MemberTitle :memberTitle="'信用支付'"></MemberTitle>

    <!-- 内容 -->
    <div class="credit_content">
      <div class="price_list">
        <div class="price_item">
          <div class="tit">全部待还</div>
          <div class="price_detail">
            <text>￥</text>
            <text>{{ CreditInfo.data.repayAmount ? Number(CreditInfo.data.repayAmount).toFixed(0) : '--' }}</text>
            <text v-if="CreditInfo.data.repayAmount">.{{ Number(CreditInfo.data.repayAmount).toFixed(2).split('.')[1]
            }}</text>
          </div>
        </div>
        <div class="price_item">
          <div class="tit">逾期金额</div>
          <div class="price_detail">
            <text>￥</text>
            <text>{{ CreditInfo.data.overdueAmount ? Number(CreditInfo.data.overdueAmount).toFixed(0) : '--' }}</text>
            <text v-if="CreditInfo.data.overdueAmount">.{{ Number(CreditInfo.data.overdueAmount).toFixed(2).split('.')[1]
            }}</text>
          </div>
        </div>
        <div class="price_item">
          <div class="tit">可用额度</div>
          <div class="price_detail">
            <text>￥</text>
            <text>{{ CreditInfo.data.creditAvailable ? Number(CreditInfo.data.creditAvailable).toFixed(0) : '--' }}</text>
            <text v-if="CreditInfo.data.creditAvailable">.{{
              Number(CreditInfo.data.creditAvailable).toFixed(2).split('.')[1] }}</text>
          </div>
        </div>
        <div class="price_item">
          <div class="tit">总额度</div>
          <div class="price_detail">
            <text>￥</text>
            <text>{{ CreditInfo.data.creditLimit ? Number(CreditInfo.data.creditLimit).toFixed(0) : '--' }}</text>
            <text v-if="CreditInfo.data.creditLimit">.{{ Number(CreditInfo.data.creditLimit).toFixed(2).split('.')[1]
            }}</text>
          </div>
        </div>
      </div>
      <!-- tab -->
      <div class="tabList flex_row_start_center">
        <div @click="changeTab(index)" class="tit" :class="currentTabIndex == index ? 'tit_active' : ''"
          v-for="(item, index) in tabList" :key="index">
          {{ item }}
        </div>
      </div>
      <!-- 搜索 -->
      <div v-if="currentTabIndex == 0" class="search flex_row_start_center">
        <el-select class="selectSearch" v-model="selectValue" placeholder="Select">
          <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-input class="input" placeholder="请输入信用单号/订单号" v-model="orderNumber" clearable @clear="clear"></el-input>
        <el-button class="btn" @click="searchBill">搜索</el-button>
      </div>

      <div v-if="currentTabIndex == 0" class="table">
        <el-table :data="billList.data" style="width: 100%" empty-text="暂无数据"
          :header-cell-style="{ 'text-align': 'center', background: '#fafafa' }" :cell-style="{ 'text-align': 'center' }">
          <el-table-column prop="billSn" label="信用单号" width="160" />
          <el-table-column prop="orderSn" label="订单号" width="160" />
          <el-table-column prop="amount" label="订单金额" width="139" />
          <el-table-column prop="createTime" label="下单时间" width="164" />
          <el-table-column prop="lastRepayDate" label="最后还款日" width="164" />
          <el-table-column prop="billStateValue" label="账单状态" width="164" />
          <el-table-column label="操作" width="167">
            <template #default="scope">
              <text @click="showPayDig(scope.row)" class="payFor" v-if="scope.row.billState == 20 || scope.row.billState == 50">还款</text>
              <text v-else>--</text>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 额度明细 -->
      <div v-if="currentTabIndex == 1" class="table">
        <el-table :data="creditBillLogList.data" style="width: 100%" empty-text="暂无数据"
          :header-cell-style="{ 'text-align': 'center', background: '#fafafa' }" :cell-style="{ 'text-align': 'center' }">
          <el-table-column prop="createTime" label="时间" width="233" />
          <el-table-column prop="billSn" label="订单号" width="279" />
            <!-- <template #default="{row}">
              <text>{{ row.description.split('-')[1].substring(2) }}</text>
            </template> -->
          <!-- </el-table-column> -->
          <el-table-column prop="description" label="类型" width="222" >
            <template #default="{row}">
              <text>{{ row.description.split('-')[0] }}</text>
            </template>
          </el-table-column>
          <el-table-column prop="changeValue" label="金额" width="222" >
            <template #default="{row}">
              <text :class="Number(row.changeValue) < 0 ? 'active_red' : ''">{{ row.changeValue }}</text>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 额度记录 -->
      <div v-if="currentTabIndex == 2" class="table">
        <el-table :data="creditLogList.data" style="width: 100%" empty-text="暂无数据"
          :header-cell-style="{ 'text-align': 'center', background: '#fafafa' }" :cell-style="{ 'text-align': 'center' }">
          <el-table-column prop="createTime" label="时间" width="350" />
          <el-table-column prop="description" label="原因" width="340" />
          <el-table-column prop="afterChangeAmount" label="调整后总额度" width="272" />
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pageTo">
        <el-pagination background layout="prev, pager, next" :total="pagination.total" :page-size="pagination.pageSize"
          v-model:currentPage="pagination.current" @current-change="handleCurrentChange" />
      </div>

      <!-- 弹窗 -->
      <el-dialog title="还款" class="el_dialog_bill" v-model="InvoiceFlag" width="655px" lock-scroll="false" top="10%" :before-close="closeFun">
        <div class="dig_content">
          <div class="pay">
            <text>还款金额：</text>
            <text>{{ Number(repayment.data.amount).toFixed(2) }}</text>
          </div>

          <div class="offPayInfo">
            <div class="title">收款信息</div>
            <div class="item_info">
              <text>户名：</text>
              <text>{{ bankInfo.admin_bank_account_name ? bankInfo.admin_bank_account_name : '未设置' }}</text>
            </div>
            <div class="item_info">
              <text>开户行：</text>
              <text>{{ bankInfo.admin_bank_name ? bankInfo.admin_bank_name : '未设置' }}</text>
            </div>
            <div class="item_info">
              <text>帐号：</text>
              <text>{{ bankInfo.bank_account_number ? bankInfo.bank_account_number : '未设置' }}</text>
            </div>
          </div>
          <div class="offPayInfo">
            <div class="title">请上传付款凭证</div>
            <div class="upImg flex_row_center_center">
              <el-upload class="avatar-uploader" :action="apiUrl + 'v3/oss/common/upload'" :show-file-list="false"
                :on-success="handleAvatarSuccess" :data="upload_data" name="file" :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <el-icon v-else class="avatar-uploader-icon">
                  <Plus />
                </el-icon>
              </el-upload>
            <!-- <div class="upload">+</div>
                    <img class="img" src="" alt="" v-if="false" /> -->
            </div>
            <div class="notPay">
              如果暂时无法支付，请在完成支付后上传付款凭证。
            </div>
          </div>
        </div>
        <template #footer>
          <span class="dialog-footer flex_row_center_center">
            <el-button class="el_btn_pay" size="small" @click="payOrder">确认还款</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
  
<script>
import { onMounted, reactive, ref, getCurrentInstance, watchEffect, computed } from "vue";
import MemberTitle from "../../../components/MemberTitle";
import { ElMessage, ElPagination } from "element-plus";
import { Plus } from '@element-plus/icons'
import { useStore } from 'vuex'
import { apiUrl } from '../../../utils/config'
export default {
  name: "Balance",
  components: {
    MemberTitle,
    Plus
  },
  setup() {
    const store = useStore()
    const { proxy } = getCurrentInstance();
    const selectValue = ref(0);
    const orderNumber = ref('');
    const imageUrl = ref('')
    const upload_data = reactive({
      source: "evaluate",
    });
    const bankInfo = reactive({
      admin_bank_account_name: '',
      bank_account_number: '',
      admin_bank_name: ''
    })
    const selectOptions = reactive([
      { value: 0, label: "全部" },
      { value: 10, label: "未入账" },
      { value: 20, label: "待还款" },
      { value: 30, label: "待审核" },
      { value: 40, label: "已还款" },
      { value: 50, label: "已逾期" },
    ]);
    const currentTabIndex = ref(0);
    const InvoiceFlag = ref(false);
    const tabList = reactive(["信用账单", "额度明细", "额度记录"]);
    const tableData = reactive({
      data: []
    })
    const CreditInfo = reactive({
      data: {}
    })

    const repayment = reactive({
      data: {}
    }) //还款数据

    // 页面分页
    const pagination = reactive({
      current: 1,
      pageSize: 10,
      total: 0
    })
    // 信用账单
    const billList = reactive({
      data: [],
    })
    //额度明细
    const creditBillLogList = reactive({
      data: [],
    })
    // 额度记录
    const creditLogList = reactive({
      data: [],
    })
    const memberInfo = computed(() => store.state.memberInfo);
    // 切换tab
    const changeTab = (index) => {
      if (currentTabIndex.value != index) {
        pagination.current = 1
        pagination.pageSize = 10
        pagination.total = 0
        currentTabIndex.value = index
        if (index == 0) {
          getBillList()
        }
        if (index == 1) {
          getCreditBillLogList()
        }
        if (index == 2) {
          getCreditLogList()
        }
      }
    }

    //页数改变
    const handleCurrentChange = current => {
      pagination.current = current;
      switch (currentTabIndex.value) {
        case 0:
          getBillList()
          break;
        case 1:
          getCreditBillLogList()
          break;
        case 2:
          getCreditLogList()
          break;
      }
    };
    // 展示还款弹窗
    const showPayDig = (item) => {
      InvoiceFlag.value = true;
      repayment.data = item
    };

    // 关闭弹窗
    const closeFun = () => {
      InvoiceFlag.value = false
      imageUrl.value = ''
    }
    // 还款
    const payOrder = () => {
    //   if (imageUrl.value != '') {
        let param = {}
        param.billSns = repayment.data.billSn
        param.repaidEvidence = imageUrl.value
        proxy.$post("v3/member/front/credit/repay", param).then((res) => {
          if (res.state == 200) {
            ElMessage.success(res.msg);
            InvoiceFlag.value = false
            imageUrl.value = ''
            pagination.current = 1
            getBillList()

          } else {
            ElMessage.error(res.msg);
          }
        });
    //   } else {
    //     ElMessage.error('请上传支付凭证');
    //   }
    }
    // 上传图片
    const handleAvatarSuccess = (
      response
    ) => {
      imageUrl.value = response.data.url
    }

    const beforeAvatarUpload = (rawFile) => {
      if (rawFile.type !== 'image/jpeg') {
        ElMessage.error('请上传image/jpeg格式的图片!')
        return false
      } else if (rawFile.size / 1024 / 1024 > 5) {
        ElMessage.error('最大只能上传 5MB!')
        return false
      }
      return true
    }
    // 客户信用信息
    const getCreditDetail = () => {
      proxy.$get("v3/member/front/credit/detail",).then((res) => {
        // console.log(res, '1')
        if (res.state == 200) {
          CreditInfo.data = res.data
        } else {
          ElMessage.error(res.msg);
        }
      });
    }

    const searchBill = () => {
      pagination.current = 1
      getBillList()
    }
    // 获取线下支付数据
    const getPayLine = () => {
      let param = {
        names: 'offline_pc_pay_name,offline_pc_pay_number,offline_pc_pay_bank'
      }
      proxy.$get('v3/system/front/setting/getSettings', param).then(res => {
        bankInfo.admin_bank_account_name = res.data[0]
        bankInfo.bank_account_number = res.data[1]
        bankInfo.admin_bank_name = res.data[2]
      })
    }
    // 信用账单列表
    const getBillList = () => {
      let param = {}
      param.current = pagination.current
      param.pageSize = pagination.pageSize
      param.billState = selectValue.value
      param.billOrderSn = orderNumber.value
      if (param.billState == 0) {
        param.billState = ''
      }
      proxy.$get("v3/member/front/credit/billList", param).then((res) => {
        console.log(res, '2')
        if (res.state == 200) {
          billList.data = res.data.list
          pagination.current = res.data.pagination.current
          pagination.pageSize = res.data.pagination.pageSize
          pagination.total = res.data.pagination.total
        } else {
          ElMessage.error(res.msg);
        }
      });
    }

    // 额度明细列表
    const getCreditBillLogList = () => {
      let param = {}
      param.current = pagination.current
      param.pageSize = pagination.pageSize
      proxy.$get("v3/member/front/credit/creditBillLogList", param).then((res) => {
        if (res.state == 200) {
          creditBillLogList.data = res.data.list
          pagination.current = res.data.pagination.current
          pagination.pageSize = res.data.pagination.pageSize
          pagination.total = res.data.pagination.total
        } else {
          ElMessage.error(res.msg);
        }
      });
    }

    // 额度记录列表
    const getCreditLogList = () => {
      let param = {}
      param.current = pagination.current
      param.pageSize = pagination.pageSize
      proxy.$get("v3/member/front/credit/creditLogList", param).then((res) => {
        if (res.state == 200) {
          creditLogList.data = res.data.list
          pagination.current = res.data.pagination.current
          pagination.pageSize = res.data.pagination.pageSize
          pagination.total = res.data.pagination.total
        } else {
          ElMessage.error(res.msg);
        }
      });
    }

    onMounted(() => {
      getCreditDetail();
      getBillList()

      getPayLine()
    });

    return {
      selectValue,
      selectOptions,
      tableData,
      currentTabIndex,
      tabList,
      InvoiceFlag,
      getCreditDetail,
      changeTab,
      showPayDig,
      memberInfo,
      CreditInfo,
      getBillList,
      pagination,
      billList,
      creditBillLogList,
      creditLogList,
      getCreditBillLogList,
      getCreditLogList,
      handleCurrentChange,
      orderNumber,
      searchBill,
      payOrder,
      repayment,
      handleAvatarSuccess,
      imageUrl,
      apiUrl,
      beforeAvatarUpload,
      upload_data,
      getPayLine,
      bankInfo,
      closeFun,

    };
  },
};
</script>
  
<style lang="scss" scoped>
@import "../../../style/member/creditOrder.scss";

.sld_pagination {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>